<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-row no-gutters>
        <div class="flex-grow-1"></div>
      </v-row>
    </v-col>
    <v-col cols="12">
      <video id="video" ref="video" width="100%" height="300" style="border: 1px solid gray"></video>
    </v-col>
    <v-col cols="12">
      <v-text-field name="outsideCode" label="Barcode Id" v-if="!outsideBarCode" hide-details v-model="codeId" append-icon="search" outlined dense @click:append="barCodeReceive(codeId);"/>
      <v-text-field name="code" label="Outside Barcode Id" v-else hide-details v-model="codeId" append-icon="search" outlined dense @click:append="barCodeReceive(codeId);"/>
    </v-col>
    
    <v-col cols="12" class="text-center m1">
     -- OR --
    </v-col>
    <v-col cols="12">
      <v-select
        label="Video Input Source"
        v-model="selectedDevice"
        :items="videoInputDevices"
        item-text="label"
        item-value="deviceId"
        return-object
        dense
        outlined
        @change="changeDevice"
      />
      <v-btn :disabled="disableAction" color="primary" block @click="startScan">
        <v-icon>camera_alt</v-icon>Scan
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import Hashids from "hashids";
//import { BrowserQRCodeReader, BrowserMultiFormatReader } from "@zxing/library";
import { BrowserMultiFormatReader } from "@zxing/library";

let hashids = new Hashids("info@deli@ry");

export default {
  mounted: function() {},
  props: {
    dialogStatus: Boolean,
    barCodeReceive: Function,
    outsideBarCode: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    changeDevice: function(value) {
      this.selectedDevice = value;
      this.startScan();
    },
    startScan: function() {
      this.disableAction = true;
      if (this.codeReader != null) {
        this.codeReader.reset();
      }
      //navigator.mediaDevices.getUserMedia();

      //this.codeReader = new BrowserQRCodeReader();
      this.codeReader = new BrowserMultiFormatReader();
      this.codeReader.getVideoInputDevices().then(videoInputDevices => {
        videoInputDevices.forEach(device => {});
        this.videoInputDevices = videoInputDevices;
        if (this.selectedDevice == null && this.videoInputDevices.length > 0) {
          this.selectedDevice = this.videoInputDevices[0];
          //this.changeDevice(this.videoInputDevices[0]);
        }
        const deviceId = this.selectedDevice.deviceId;
        this.codeReader
          .decodeFromInputVideoDevice(deviceId, "video")
          .then(result => {
            this.disableAction = false;
            if (this.outsideBarCode) {
              this.barCodeReceive(result.text);
              this.codeReader.reset();
              return;
            }
            let ids = hashids.decode(result.text);
            if (ids.length > 0) {
              this.barCodeReceive(ids[0]);
            }
            this.codeReader.reset();
          })
          .catch(err => {});
      });
    }
  },
  data() {
    return {
      videoInputDevices: [],
      codeReader: null,
      selectedDevice: null,
      disableAction: false,
      codeId: ""
    };
  },
  watch: {
    dialogStatus: function(value) {
      if (!value && this.codeReader) {
        this.codeReader.reset();
      } else {
        this.disableAction = false;
      }
    }
  }
};
</script>